import React, { useState, useEffect } from 'react';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import IngkaDropdownMenu from '../../IngkaDropdownMenu';
import { getFY } from '../../../utils/calculation';

const currentFY = getFY();
export const FY_OPTIONS = [currentFY, getFY(1), getFY(2), getFY(3)];

export const FY_BUDGET_FILTER_FIELD = 'fyBudgetFYs';

export const fyBudgetFilterOperator = {
  label: 'hasAnyFY',
  value: 'hasAnyFY',
  getApplyFilterFn: (filterItem: { value?: string[] }) => {
    if (!filterItem.value || filterItem.value.length === 0) {
      return null;
    }
    return (value: string[]) => {
      if (!value || !Array.isArray(value)) return false;
      return filterItem.value!.some((fy) => value.includes(fy));
    };
  },
};

export const FYBudgetFilter = () => {
  const apiRef = useGridApiContext();
  const [selectedFYs, setSelectedFYs] = useState<string[]>([]);

  const handleToggleFY = (fy: string) => {
    setSelectedFYs((prev) =>
      prev.includes(fy) ? prev.filter((f) => f !== fy) : [...prev, fy],
    );
  };

  const isFiltered = selectedFYs.length > 0;

  useEffect(() => {
    if (!isFiltered) {
      apiRef.current.deleteFilterItem({
        id: 'fy-budget-filter',
        operator: 'hasAnyFY',
        field: FY_BUDGET_FILTER_FIELD,
      });
    } else {
      apiRef.current.upsertFilterItem({
        field: FY_BUDGET_FILTER_FIELD,
        operator: 'hasAnyFY',
        value: selectedFYs,
        id: 'fy-budget-filter',
      });
    }
  }, [selectedFYs, apiRef, isFiltered]);

  return (
    <IngkaDropdownMenu
      label="FY budget"
      id="fy-budget-filter-menu"
      options={FY_OPTIONS.map((fy) => ({ value: fy, label: fy }))}
      selectedValues={selectedFYs}
      onToggle={handleToggleFY}
    />
  );
};
